import shop from '../../api/payOrder';
import { sendSuccessNotice, sendErrorNotice, getCurrentTime } from '@/commons/utils';
import Vue from 'vue';

// initial state
const state = {
    loading: false,
    selectedItem: {},
    all: [],
    total: 0
};

// getters
const getters = {};

// actions
const actions = {
    getPayOrderList({ commit }, param) {
        commit('setLoading', {loading: true});
        shop.getPayOrderList(data => {
            commit('setPayOrderList', data);
            commit('setLoading', {loading: false});
        }, Vue.http, param, this.state.authentication.token);
    },
    getPayOrderDetail({ commit }, customerId) {
        commit('setLoading', {loading: true});
        shop.getPayOrderDetail(data => {
            commit('setPayOrderDetail', data);
            commit('setLoading', {loading: false});
        }, Vue.http, customerId, this.state.authentication.token);
    },
    updatePayOrder({ commit }, payload) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                shop.updatePayOrder(data => {
                    resolve(data)
                    if(data.status == 200) {
                        commit('updatePayOrderList', data);
                        sendSuccessNotice('Thanh toán thành công.')
                    }
                }, Vue.http, payload, this.state.authentication.token);
            }, 100)
        })
    },
};

// mutations
const mutations = {
    setPayOrderList(state, res) {
        state.all = res.data;
        state.total = res.total;
    },
    setPayOrderDetail(state, item) {
        if(item.data && item.data.Orders) {
            let first_id = 0;
            for (let i = 0; i < item.data.Orders.length; i++) {
                const element = item.data.Orders[i];
                if(first_id == element.ID) {
                    element.IsChild = 1;
                }
                first_id = element.ID;
            }
        }
        state.selectedItem = item.data;
    },
    updatePayOrderList(state, res) {
        
    },
    setLoading(state, { loading }) {
        _.debounce(function () { state.loading = loading; }, 400, {
            'leading': false,
            'trailing': true
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
